import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getBuildingsInfoForGeneration } from '../../../apis/agendaApis';
import { useParams } from 'react-router-dom';
import { Box, Container, IconButton, Typography, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { formatDate, getLocalStorageItem, history, setLocalStorageItem } from '../../../_helpers';
import DataGridV2 from '../../../components/DataGridV2';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../../_constants';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import i18n from "../../../i18n";
import { INITIAL_ROW_SELECTION_MODEL } from '../../../components/DataGridV2/constants';
import { useCallback } from 'react';
import { ArrowBack } from '@mui/icons-material';
import { getBuildingListForGenerationColumns } from './buildingListForGenerationUtils';

const BuildingsListForGeneration = () => {
  const [buildingListInfoForGeneration, setBuildingListInfoForGeneration] = useState([])
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const { generationId } = useParams();
  const app = useSelector((state) => state.app);
  const { t } = useTranslation();
  const {all:allBuildings } = useSelector(state => state.buildings)
  const  classes = useStyles();
  const apiRef = useGridApiRef();
  const keyPrefix = app === apps.huisinfo ? "BUYERS_GUIDE" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_PAGINATION[keyPrefix], undefined
  ))
  
  const getBuildingListAllInfo = (data)=>{
    return data?.map((item,index)=>{
      const buildingInfo = allBuildings?.find(building=>building.buildingId === item.buildingId)
      return {...item,
        id: item?.id || item?.buildingId || `row-${index}`, 
       endDateTime:item.endDateTime ?formatDate(new Date(item.endDateTime), true):"",
       startDateTime: item.endDateTime ?formatDate(new Date(item.startDateTime), true):"",
       buyerRenterName :buildingInfo?.buyerRenterName || "",
       buildingType :buildingInfo?.buildingType || "",
       status :buildingInfo?.status || "",
       projectName :buildingInfo?.projectName || "",
       projectNo :buildingInfo?.projectNo || "",
       buildingNoIntern:buildingInfo?.buildingNoIntern || "",
      }
    })
  }


  const getBuildingListInfoForGeneration = async () => {
    setLoading(true);
    const generation = await getBuildingsInfoForGeneration(generationId)

    setBuildingListInfoForGeneration(getBuildingListAllInfo(generation.data) || [])
   
    setLoading(false)
}


  useEffect(() => {
    getBuildingListInfoForGeneration()
  }, [])

 const columns = getBuildingListForGenerationColumns({t,theme,keyPrefix,i18n,apiRef})

  const onPaginationModelChange = useCallback((newPaginationModel) => {
      setPaginationModel(newPaginationModel)
      setLocalStorageItem(
        LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_PAGINATION[keyPrefix],
        newPaginationModel
      );
    }, [keyPrefix])


  const getBuildingListForGenerationForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
    const userSelectedRows = isAllSelected ? buildingListInfoForGeneration: idsToExport.map(id => buildingListInfoForGeneration.find(item => item?.id === id));
    const results = userSelectedRows?.map(item => {
    const result = {};
    Object.keys(item).forEach(key => {
      let value = item[key];
      const columnDef = columns.find(col => col.field === key);
      const columnType = columnDef?.type;

      if (columnType === 'dateTime') {
        value = value ? formatDate(new Date(value), true) : "";
      }
      result[key] = value;
    });

    return result;
  });

  return results;
};


  return (  
     <Container maxWidth={false} className={classes.mainContainer}>
      <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
      <Box p={2} display={'flex'} alignItems={'center'} >
        <IconButton onClick={() => history.goBack()}>
          <ArrowBack/>
        </IconButton>
        <Typography variant='h6'>{t("agenda.timeSlots.objectOverview")}</Typography>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0 }}>
            <DataGridV2
            localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_SEARCH_TEXT[keyPrefix]}
            localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_FILTER[keyPrefix]}
            localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_SORT[keyPrefix]}
            localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_ORDER[keyPrefix]}
            localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_WIDTH[keyPrefix]}
            localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.BUILDING_LIST_FOR_GENERATION_COLUMN_VISIBILITY[keyPrefix]}
            apiRef={apiRef}
            loading={loading}
            rows={buildingListInfoForGeneration}
            columns={columns}
            pagination
            checkboxSelection
            {...(!!paginationModel && { paginationModel })}
            onPaginationModelChange={onPaginationModelChange}
            toolbarProps={{
              title: t("general.object.select"),
              selectedRows: rowSelectionModel,
              getData: getBuildingListForGenerationForPrintAndDownload,
            }}
            filterMode="client"
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
          />
          </Box>
          </Box>
      </Container>
  );
}

export default BuildingsListForGeneration


const useStyles = makeStyles((theme) => ({
        mainContainer: {
        height: "100%",
        width: "100%",
        overflow: "auto",
        padding: 0,

    },
}));
